export const PredeterminedMyProjects = [
  {
    name: 'Connect & Play',
    message: 'A simple socket service that enable keyboard input transfer between computers.',
    imageUrl: 'https://cdn.discordapp.com/attachments/880347887232512030/880347896426430484/unknown.png',
    hyperlink: 'https://github.com/stevennovaryo/connect-and-play',
  },
  {
    name: 'Nightbot',
    message: 'A private use discord bot for web scraping and simple games.',
    imageUrl: 'https://cdn.discordapp.com/attachments/880347887232512030/880360801163178004/unknown.png',
    hyperlink: 'https://discord.com/api/oauth2/authorize?client_id=757394120192032849&permissions=0&scope=bot',
  },
  {
    name: 'CP Contest',
    message: 'Authored many problems in TOKI Regular Open Contest.',
    imageUrl: 'https://cdn.discordapp.com/attachments/880347887232512030/880349702657306644/unknown.png',
    hyperlink: 'https://tlx.toki.id/contests',
  }
]